import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';

import { editContent, InnerContent } from '../../../modules/editor';
import { RootState } from '../../../modules';

import Select from '../../../components/Dropdown/Select';
import ColorPicker from '../../../components/ColorPicker/ColorPicker';
import BorderStyleDropdown from '../../../components/Dropdown/BorderStyleDropdown';

type Props = {
	innerContent: InnerContent;
	style: any;
	contentId: number;
	contentIndex: number;
};

function PartitionToolbar({ innerContent, style, contentId, contentIndex }: Props) {
	const dispatch = useDispatch();	
	const [showCropModal, setShowCropModal] = useState(false);
	
	const editor = useSelector((state: RootState) => state.editor);

	const iconImage = require.context('../../../assets/images/', true);

	const contentTarget = `${contentId}/content/${contentIndex}`;
	const styleTarget = `${contentId}/style/${contentIndex}`;

	let cropper:any = {};

	const openCropModal = () => {		
		setShowCropModal(true);
	}

	const closeCropModal = () => {
		setShowCropModal(false);
	}

	return (
		<>
			<div className="toolbar partition">
				<div className="group">
					<BorderStyleDropdown
						target={`${styleTarget}/partition/borderTopStyle`}
						value={style?.borderTopStyle}
						option={editor.option.borderStyle}
					/>
					<Select
						target={`${styleTarget}/partition/borderTopWidth`}
						value={style?.borderTopWidth}
						options={editor.option.borderWidthPartition}
						size="small"
					/>
					<ColorPicker
						target={`${styleTarget}/partition/borderTopColor`}
						value={style?.borderTopColor}
						showValueText={false}
						showLabel={false}
					>배경 색상</ColorPicker>
				</div>
			</div>
		</>
	);
}

export default PartitionToolbar;